export default __webpack_public_path__ + "static/media/access-two-false.987a0fc1.svg";